// Offer details pop-up
const offer_popBtn = document.querySelector(".addition_offerWrap .offer_popBtn");
const offer_popOverlay = document.querySelector(".offer_popOverlay");
const offer_content = document.querySelector(".addition_offerWrap .offer_content");
const offer_close = offer_content.querySelector(".close_offer");
const offer_body = document.querySelector("body.template_product");

offer_popBtn.addEventListener("click", function() {
  offer_popOverlay.classList.add("active");
  offer_content.classList.add("active");
  offer_body.classList.add("noScroll");
});

offer_popOverlay.addEventListener("click", function(){
  this.classList.remove("active");
  offer_content.classList.remove("active");
  offer_body.classList.remove("noScroll");
})

offer_close.addEventListener("click", function(){
  offer_popOverlay.classList.remove("active");
  offer_content.classList.remove("active");
  offer_body.classList.remove("noScroll");
})
// Offer details pop-up



// Pop-up box
  const pop_up_btn = document.querySelector(".cust_mediaControl");
  const popOverlay = document.querySelector(".mediaControl_popOverlay");
  const popContainer = document.querySelector(".custom_mediaControl_wrap");
  const closeBtn = document.querySelector(".media_closeBtn");
  const body = document.querySelector(".template-product"); 
  
  pop_up_btn.addEventListener("click", function() {
    const selected_thumb_type = $('.product-gallery__thumbnail_item.current').data('media-type');
    const selected_thumb_index = parseInt($('.product-gallery__thumbnail_item.current').data('index'));
    console.log('selected_thumb_type ',selected_thumb_type);
    if(selected_thumb_type == 'image'){
      $('.mediaControl_Main .tab__hdngs .tab__hdng.video-hdng').removeClass('active');
      $('.mediaControl_Main .tab__cntnts .tab__cntnt.video_content').removeClass('active');
      $('.mediaControl_Main .tab__hdngs .tab__hdng.image-hdng').addClass('active');
      $('.mediaControl_Main .tab__cntnts .tab__cntnt.img_content').addClass('active');
      $(`.tab__cntnt.img_content.active .rimage.media_item[data-index="${selected_thumb_index}"]`).click();
    }else{
      $('.mediaControl_Main .tab__hdngs .tab__hdng.image-hdng').removeClass('active');
      $('.mediaControl_Main .tab__cntnts .tab__cntnt.img_content').removeClass('active');
      $('.mediaControl_Main .tab__hdngs .tab__hdng.video-hdng').addClass('active');
      $('.mediaControl_Main .tab__cntnts .tab__cntnt.video_content').addClass('active');
      $(`.tab__cntnt.video_content.active .rvideo.media_item[data-index="${selected_thumb_index}"]`).click();
      document.querySelector(`.tab__cntnt.video_content.active .content_inner_left .rvideo.media_item[data-index="${selected_thumb_index}"] video`).play();
      document.querySelector(`.tab__cntnt.video_content.active .content_inner_left .rvideo.media_item[data-index="${selected_thumb_index}"] video`).muted = false;
    }
    popOverlay.classList.add("active");
    popContainer.classList.add("active");
    body.classList.add("noScroll");
  });
  
  $('.product-gallery__thumbnail_item[data-media-type="video"]').click(function(){
      const index = $(this).data('index');
      $('.mediaControl_Main .tab__hdngs .tab__hdng.image-hdng').removeClass('active');
      $('.mediaControl_Main .tab__cntnts .tab__cntnt.img_content').removeClass('active');
      $('.mediaControl_Main .tab__hdngs .tab__hdng.video-hdng').addClass('active');
      $('.mediaControl_Main .tab__cntnts .tab__cntnt.video_content').addClass('active');
      popOverlay.classList.add("active");
      popContainer.classList.add("active");
      body.classList.add("noScroll");
      $(`.tab__cntnt.video_content.active .rvideo.media_item[data-index="${index}"]`).click();
      document.querySelector(`.tab__cntnt.video_content.active .content_inner_left .rvideo.media_item[data-index="${index}"] video`).play();
      document.querySelector(`.tab__cntnt.video_content.active .content_inner_left .rvideo.media_item[data-index="${index}"] video`).muted = false;
  });
  
  popOverlay.addEventListener("click", function(){
    this.classList.remove("active");
    popContainer.classList.remove("active");
    body.classList.remove("noScroll");
    let video_popContent = popContainer.querySelector(".video_content .content_inner_left");
    let video_popItem = video_popContent.querySelectorAll(".rvideo__video");
    video_popItem.forEach((video)=>{
      video.pause();
      video.muted = true;
    })
  })
  
  closeBtn.addEventListener("click", function(){
    popOverlay.classList.remove("active");
    popContainer.classList.remove("active");
    body.classList.remove("noScroll");
    let video_popContent = popContainer.querySelector(".video_content .content_inner_left");
    let video_popItem = video_popContent.querySelectorAll(".rvideo__video");
    video_popItem.forEach((video)=>{
      video.pause();
      video.muted = true;
    })
  })
// Pop-up box

// Trigger to open Pop-up
  document.querySelector(".product-gallery__main_slider-wrapper .product-gallery__main_slider").addEventListener("click", function(e) {
    e.preventDefault();
    const gallery = this.closest(".product-gallery");
    if (gallery) {
      const controlBtn = gallery.querySelector(".custom_mediaControl_btnWrap .cust_mediaControl");
      if (controlBtn) {
        controlBtn.click();
      }
    }
  });
// Trigger to open Pop-up

// Tab function between Video/Image
  let lastPlayedVideo = null; // global reference to remember the last interacted video

  // Track when any video is played/clicked
  document.querySelectorAll(".content_inner_left .rvideo__video").forEach(video => {
    video.addEventListener("play", () => {
      lastPlayedVideo = video;
    });
  });
  
  const tab__hdng = document.querySelectorAll(".mediaControl_Main .tab__hdngs .tab__hdng");
  const tab__cntnt = document.querySelectorAll(".mediaControl_Main .tab__cntnts .tab__cntnt");
  
  tab__hdng.forEach((item, index) => {
    item.addEventListener("click", () => {
      // Remove active classes
      tab__hdng.forEach(tab => tab.classList.remove("active"));
      tab__cntnt.forEach(content => content.classList.remove("active"));
  
      // Pause/reset only the last played video
      if (lastPlayedVideo) {
        lastPlayedVideo.pause();
        lastPlayedVideo.currentTime = 0;
        lastPlayedVideo.muted = true;
      }
  
      // Activate clicked tab
      item.classList.add("active");
      tab__cntnt[index].classList.add("active");
  
      // Check if the tab has video content
      const content = tab__cntnt[index];
      const videos = content.querySelectorAll(".content_inner_left .rvideo__video");
  
      if (videos.length > 0) {
        let videoToPlay;
  
        // Play last watched video if it's in this tab
        if (lastPlayedVideo && content.contains(lastPlayedVideo)) {
          videoToPlay = lastPlayedVideo;
        } else {
          // Otherwise, play the first video
          videoToPlay = videos[0];
        }
  
        // Play and unmute
        videoToPlay.muted = false;
        videoToPlay.play().catch(err => {
          console.warn("Autoplay with sound may be blocked:", err);
        });
  
        // Store this as last played (if not already set)
        if (!lastPlayedVideo) {
          lastPlayedVideo = videoToPlay;
        }
      }
    });
  });
// Tab function between Video/Image

// Inner Tab function for Image type item
  const img_tab__btn = document.querySelectorAll(".mediaControl_Main .content_inner_right .rimage");
  const img_tab__cntnt = document.querySelectorAll(".mediaControl_Main .content_inner_left .rimage");
  console.log("Clicked thumbnail");
  
  img_tab__btn[0].classList.add("active");
  img_tab__cntnt[0].classList.add("active");
  
  img_tab__btn.forEach((item, index) => {
    item.addEventListener("click", () => {
      img_tab__btn.forEach(tab => tab.classList.remove("active"));
      img_tab__cntnt.forEach(content => content.classList.remove("active"));
  
      item.classList.add("active");
      img_tab__cntnt[index].classList.add("active");
    });
  });
// Inner Tab function for Image type item

// Inner Tab function for Video type item
  const video_tab__btn = document.querySelectorAll(".mediaControl_Main .content_inner_right .rvideo");
  const video_tab__cntnt = document.querySelectorAll(".mediaControl_Main .content_inner_left .rvideo");
  
  // Set the initial active tab
  video_tab__btn[0].classList.add("active");
  video_tab__cntnt[0].classList.add("active");
  
  // Handle tab switching
  function switchToTab(index) {
    video_tab__btn.forEach(tab => tab.classList.remove("active"));
    video_tab__cntnt.forEach(content => {
      const video = content.querySelector('video');
      video.pause();
      video.currentTime = 0;
      content.classList.remove("active");
    });
  
    video_tab__btn[index].classList.add("active");
    video_tab__cntnt[index].classList.add("active");
  
    const video = video_tab__cntnt[index].querySelector('video');
    video.muted = false;
    video.play();
  }
  
  // Add click listeners to tabs
  video_tab__btn.forEach((item, index) => {
    item.addEventListener("click", () => switchToTab(index));
  });
  
  // Add 'ended' event listeners for auto-switching
  video_tab__cntnt.forEach((content, index) => {
    const video = content.querySelector('video');
    video.addEventListener('ended', () => {
      const nextIndex = index + 1;
      if (nextIndex < video_tab__cntnt.length) {
        switchToTab(nextIndex);
      }
      // If it's the last video, do nothing.
    });
  });


  // Show video timing length
  const video_thumbnail = document.querySelectorAll(".mediaControl_Main .content_inner_right .rvideo .rvideo__video");
  video_thumbnail.forEach(function (video) {
    console.log(video);
    video.addEventListener("loadedmetadata", function(){
      const duration = video.duration;
      const minutes = Math.floor(duration / 60);
      const seconds = Math.floor(duration % 60).toString().padStart(2, '0');
      const durationText = `${minutes}:${seconds}`;
  
      // Create a duration overlay
      const durationElement = document.createElement("div");
      durationElement.className = "video-duration-overlay";
      durationElement.textContent = durationText;
      console.log(durationElement);
  
      // Position it in the bottom-right corner of the video container
      video.parentNode.style.position = 'relative';
      video.parentNode.appendChild(durationElement);
    });
  });
// Inner Tab function for Video type item